import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { isEmpty, isPropertyEmpty } from '../utils/object-util';

@Directive({
  selector: '[thNotEmptyValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NotEmptyValidatorDirective,
      multi: true
    }
  ]
})
export class NotEmptyValidatorDirective implements Validator {
  /**
   * The path to the property on the `ngModel` that needs to be checked for emptiness.
   */
  @Input() notEmptyPropertyPath: string;

  validate(control: AbstractControl): ValidationErrors | null {
    if (isEmpty(control && control.value) || isPropertyEmpty(control.value, this.notEmptyPropertyPath)) {
      return { emptyObject: true };
    } else {
      return null;
    }
  }
}
